import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables';
export const GetElmahErrors = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Elmah/GetElmahErrors`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}